module.exports = __webpack_public_path__ + "img/medium-delete.8d357c25.svg";